import IntlMessage from '../../util/IntlMessage';
import * as React from 'react';

export const required = (value: any) => {
    return (value || value === 0 ? undefined : <IntlMessage id='common.validation.required'/>);
};
